export default "__VITE_ASSET__BoOXDuWE__"